<template>
  <o-version-cards
    :default-index="-1"
    :items="filtered_items"
    @create="createNew"
    can-add
    default-button-text="Versions"
    text-value="version_number"
    body-classes="p-0"
    title="Versions"
    v-model="currentVersion"
  >
    <template v-slot:buttonContent="{ current_index }">
      <span v-if="filtered_items && current_index > -1"
        >{{ current_index + 1 }}.
        <date-display
          :value="filtered_items[current_index].active_start_date"
          format="D/MM/YYYY hh:mm"
        ></date-display
        >&nbsp;
        <span
          class="badge badge-success"
          v-if="current_index === filtered_items.length - 1"
          >Latest</span
        >
      </span>
      <span v-else>Version</span>
    </template>

    <template v-slot:versionTitle="props">
      {{ props.index + 1 }}.
      <date-display
        :value="props.item.active_start_date"
        format="D/MM/YYYY hh:mm"
      ></date-display>
      &nbsp;
      <span
        class="badge badge-success"
        v-if="props.index === filtered_items.length - 1"
        >Latest</span
      >
    </template>

    <template slot-scope="props">
      <item-form
        v-if="items"
        :item="items[props.index]"
        :server-errors="_se[props.index]"
        :form-state="formState"
        :level="level"
      ></item-form>
    </template>
  </o-version-cards>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify.js";
import { CreateDefaultItem } from "../../../../vue-ocom/schema/schema_utils.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../../vue-ocom/mixins";

import OVersionCards from "../../../../vue-ocom/components/table/OVersionCards.vue";

import ItemForm from "./ItemForm.vue";

export default {
  name: "FormTemplateVersionFormCards",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("FormTemplateVersion"),
    CreateCodeTableFetchMixin([]),
  ],
  components: { ItemForm, OVersionCards },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(schema.FormTemplateVersion, {}),
      newChild: CreateDefaultItem(schema.FormTemplateVersion),

      currentVersion: -1,
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
    canSee(schema, field_name) {
      /* Here we can check if they have permission for the field */
      return true;
    },
    createNew() {
      if (this.items.length < 1) {
        // no items use newChild
        this.items.push(_.cloneDeep(this.newChild));
      } else {
        const newItem = _.cloneDeep(this.items[this.items.length - 1]);

        // Remove some fields so it's NEW
        delete newItem.pk;
        delete newItem.id;
        newItem.active_start_date = new Date();
        newItem.active_end_date = null;

        this.items.push(newItem);
      }

      this.currentVersion = this.items.length - 1; // select latest
    },
  },
  computed: {
    filtered_items() {
      return this.items;
    },
  },
  created() {
    // this.loadCodeTables()
  },
};
</script>
